export class Transition {
	constructor(document, newDocument, callback) {
		this.document = document;
		this.newDocument = newDocument;
		this.callback = callback;
	}

	start(selector) {
		let oldMain = this.document.querySelector(selector);
		let newMain = document.createElement(selector);
		newMain.innerHTML = this.newDocument.querySelector(selector).innerHTML;
		newMain.classList.add("transition");
		oldMain.classList.add("old-main");
		oldMain.classList.add("transition-out");

		let noAnimTimeout = setTimeout(() => {
			this.finish(oldMain, newMain);
		}, 100);
		newMain.addEventListener("animationstart", e => {
			clearTimeout(noAnimTimeout);
			noAnimTimeout = null;
		})
		newMain.addEventListener("animationend", e => {
			this.finish(oldMain, newMain);
			if(this.callback) {
				this.callback();
			}
		});

		oldMain.after(newMain);
	}

	finish(oldMain, newMain) {
		oldMain.remove();
		newMain.classList.remove("transition");
		newMain.classList.add("transition-complete");
		newMain.closest("html").scrollTo(0, 0);
		setTimeout(() => {
			newMain.classList.remove("transition-complete");
		}, 100);
		if(this.callback) {
			this.callback();
		}
	}

	stillActive() {
		return null !== document.querySelector("main.transition");
	}
}
